import { Filter } from "@/interfaces/filter.interface";

export interface FilterOption extends Filter {
  type?: "single-select" | "multi-select";
}

export const filterOrderOptions: { [key: string]: FilterOption[] } = {
  printStatus: [
    {
      title: "Pending",
      value: "PENDING",
      selected: false,
      color: "#78909c",
      type: "single-select",
    },
    {
      title: "In Queue",
      value: "IN_QUEUE",
      selected: false,
      color: "#ffb300",
      type: "single-select",
    },
    {
      title: "Processing",
      value: "PROCESSING",
      selected: false,
      color: "#2196f3",
      type: "single-select",
    },
    {
      title: "Done",
      value: "DONE",
      selected: false,
      color: "#4caf50",
      type: "single-select",
    },
    {
      title: "Failed",
      value: "FAILED",
      selected: false,
      color: "#f44336",
      type: "single-select",
    },
  ],
  printErrorLabels: [
    {
      title: "Empty File",
      value: "empty_file",
      selected: false,
      type: "multi-select",
    },
    // {
    //   title: "Error File",
    //   value: "error_checking_file",
    //   selected: false,
    //   type: "multi-select",
    // },
    {
      title: "Missing Photo",
      value: "missing_photo",
      selected: false,
      type: "multi-select",
    },
    {
      title: "Photo AI Corrupted",
      value: "photo_ai_corrupted",
      selected: false,
      type: "multi-select",
    },
  ],
  // AIGeneratorStatus: [
  //   {
  //     title: "AI Generator Error",
  //     value: "Failed",
  //     selected: false,
  //     type: "multi-select",
  //   },
  // ],
};

export const FILTER_DISPLAY_TITLES: Record<string, string> = {
  printErrorLabels: "Print Error",
  printStatus: "Print Status",
  status: "Status",
  organizationId: "Organization",
  action: "Action",
  scope: "Scope",
};
